import { ToggleGroupItem } from 'components/ui/toggle-group';
import { SingleChoiceGroup } from '../SingleChoiceGroup';

type Props<Value extends string> = {
    /** Names the group for a screen reader. */
    label: string;
    value: Value;
    options: { value: Value; label: string }[];
    onChange: (value: Value) => void;
};

/** One choice out of a few as a row of pills, the chosen one tinted: what narrows a list that is already loaded. */
export function FilterPills<Value extends string>({ label, value, options, onChange }: Props<Value>) {
    return (
        <SingleChoiceGroup aria-label={label} value={value} onChange={onChange} spacing={1.5} className="flex-wrap">
            {options.map((option) => (
                <ToggleGroupItem
                    key={option.value}
                    value={option.value}
                    className="border-border-control bg-card text-foreground-secondary text-meta hover:bg-card aria-pressed:border-primary-wash-border aria-pressed:bg-primary-tint aria-pressed:text-primary-strong h-[30px] rounded-full border px-3"
                >
                    {option.label}
                </ToggleGroupItem>
            ))}
        </SingleChoiceGroup>
    );
}
